// providerslice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    
    "patient_id": '',
    "user_id":'',
    "duration_hours":'',
    "duration_minutes":'',
    "duration_seconds":'',
    "notes":'',
    
    "patient_id_inverse": '',
    "user_id_inverse":'',
    "duration_inverse":'',
    "notes_inverse":'',

    "match": false,
    "wellnessReportSearchApplied": false,

};

const wellnessReportSearchSlice = createSlice({
    name: 'wellnessReportSearch',
    initialState,
    reducers: {
        setWellnessReportSearch(state, action) {
            return { ...state, ...action.payload };
        },
        resetWellnessReportSearch(state) {
            return { ...initialState, wellnessReportSearchApplied: false }; // Reset state and flag
        },
        setWellnessReportSearchApplied(state) {
            state.wellnessReportSearchApplied = true; // Directly set searchApplied to true
        },
    },
});

// eslint-disable-next-line max-len
export const { setWellnessReportSearch, resetWellnessReportSearch, setWellnessReportSearchApplied } = wellnessReportSearchSlice.actions;

export default wellnessReportSearchSlice.reducer;